import { supabase } from "@/integrations/supabase/client";

export async function seedTestData(userId: string, workspaceId: string) {
  try {
    // Check if data already exists
    const { data: existingGoals } = await supabase
      .from("goals")
      .select("id")
      .eq("workspace_id", workspaceId)
      .limit(1);

    if (existingGoals && existingGoals.length > 0) return; // Already seeded

    // Sample goals — one per category
    const goals = [
      { title: "Build our emergency fund", description: "Save 6 months of expenses together", category: "Financial" },
      { title: "Run a half marathon together", description: "Train consistently and cross the finish line as a team", category: "Health" },
      { title: "Weekly date nights", description: "Protect one evening a week just for us", category: "Dating & Family" },
      { title: "Read 24 books this year", description: "12 each — share highlights monthly", category: "Personal" },
    ];

    for (const goal of goals) {
      const { data: g } = await supabase
        .from("goals")
        .insert({
          workspace_id: workspaceId,
          created_by: userId,
          title: goal.title,
          description: goal.description,
          category: goal.category,
        })
        .select()
        .single();

      if (g) {
        // Add a sample key result
        await supabase.from("key_results").insert({
          goal_id: g.id,
          title: `First milestone for "${goal.title}"`,
          progress: Math.floor(Math.random() * 40),
        });
      }
    }

    // Sample board meeting reflection
    const currentMonth = new Date().toLocaleDateString("en-US", { month: "long", year: "numeric" });
    await supabase.from("board_meetings").insert({
      workspace_id: workspaceId,
      author_id: userId,
      month: currentMonth,
      went_well: "We started using Together OS to align on our goals. Feeling more connected already.",
      did_not_go_well: "We didn't carve out enough time for deep conversations this month.",
      could_be_better: "Schedule a specific evening each week for our board meeting prep.",
      is_locked: false,
      submitted_at: new Date().toISOString(),
    });

    // Sample vision items
    const visionItems = [
      { type: "text", content: "We are building a life of intention, not reaction.", color: "bg-sage-light" },
      { type: "note", content: "By 2027: own our first home together, travel to Japan, and feel financially free.", color: "bg-terracotta-light" },
    ];

    for (const item of visionItems) {
      await supabase.from("vision_items").insert({
        workspace_id: workspaceId,
        created_by: userId,
        type: item.type,
        content: item.content,
        color: item.color,
      });
    }

    // Sample todo
    await supabase.from("todos").insert({
      workspace_id: workspaceId,
      created_by: userId,
      content: "Plan our first monthly board meeting 💛",
      color: "bg-sage-light",
    });

    console.log("Test data seeded successfully");
  } catch (e) {
    console.warn("Seed failed:", e);
  }
}
